<template>
  <div>
    <b-modal
      title="批次合併帳單"
      size="xl"
      centered
      hide-footer
      header-class="head-modal"
      :no-close-on-backdrop="true"
      v-model="modalShow"
    >
      <b-alert show variant="warning">
        已勾選未繳金額總計：{{ tickedTotal }}
      </b-alert>

      <b-form-tags
        v-model="unPaidBill.billId"
        no-outer-focus
        no-add-on-enter class="mb-2"
      >
        <template v-slot="{ tags, inputAttrs, inputHandlers, tagVariant, removeTag }">
          <b-form @submit.prevent="addTag(inputAttrs)">
            <b-input-group class="mb-2">
              <b-form-input v-bind="inputAttrs" v-on="inputHandlers" placeholder="請輸入關鍵字後按Enter" class="form-control" :state="state"></b-form-input>

              <b-input-group-append>
                <b-button @click="addTag(inputAttrs)" variant="primary">Add</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form>

          <div class="d-inline-block" style="font-size: 1.5rem;">
            <b-form-tag v-for="tag in unPaidBill.billId"
              @remove="removeTags(tag)"
              :key="tag"
              :title="tag"
              :variant="tagVariant"
              class="mr-1"
            >
              {{ tagName(tag) }}
            </b-form-tag>
          </div>
        </template>
      </b-form-tags>

      <tables-page
       :tableData="unPaidBill.table_data"
        :tableFields="unPaidBill.table_fields"
        :isBackendSorting="false"
      >
        <template #head(checkbox)>
          <b-form-checkbox v-model="status.isCheckboxAll" @change="toggleCheckboxAll"></b-form-checkbox>
        </template>

        <template #cell(checkbox)="row">
           <b-form-checkbox v-if="!row.item.order_create" v-model="row.item.checkbox"></b-form-checkbox>
        </template>

        <template #cell(no)="row">
          {{ row.index + 1 }}
        </template>

        <template #cell(join_date)="row">
          {{ convertRocDate(row.item.join_date) }}
        </template>

        <template #cell(order_create)="row">
          <h4>
            <b-badge :variant="row.item.order_create ? 'warning': 'light'">{{ row.item.order_create ? '已合併': '未合併' }}</b-badge>
          </h4>
        </template>
      </tables-page>

      <div class="text-center mt-4">
        <b-button
          class="mr-2"
          variant="success"
          size="sm"
          :disabled="selectNum < 2"
          @click="sumit"
        >
          確定
        </b-button>

        <b-button
          variant="danger"
          size="sm"
          class="mr-4"
          @click="$emit('change', false)"
        >
          取消
        </b-button>
      </div>

      <b-overlay :show="status.isLoading" no-wrap></b-overlay>
    </b-modal>
  </div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import datePicker from '@/components/common/DatePicker';
import billApi from "@/models/API/billApi";
import { convertRocDate } from "@/models/HELPERS/common.js";

export default {
  name: 'BatchMergeBillModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    TablesPage,
    datePicker
  },
  data () {
    return {
      unPaidBill: {
        table_fields: [
          {
            key: "checkbox",
            label: "",
          },
          {
            key: "no",
            label: "No",
          },
          {
            key: "number",
            label: "契約編號",
          },
          {
            key: "member_name",
            label: "互助人姓名",
          },
          {
            key: "join_date",
            label: "入會日期"
          },
          {
            key: "seniority_month",
            label: "年資(月)"
          },
          {
            key: "help_total",
            label: "已繳互助金"
          },
          {
            key: "total_1",
            label: "未繳金額"
          },
          {
            key: "pay_count",
            label: "繳費次數"
          },
          {
            key: "unpay_count",
            label: "未繳期數"
          },
          {
            key: "order_create",
            label: "合併狀態"
          },
        ],
        table_data: [],
        billId: []
      },
      status: {
        isCheckboxAll: false,
        isLoading: false
      },
      state: null
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
    tickedTotal() {
      if (this.unPaidBill.table_data.length === 0) return 0;

      const total = this.unPaidBill.table_data.reduce((accumulator, currentValue) => {
        return currentValue.checkbox ? accumulator + Number(currentValue.total_1) : accumulator
      }, 0);

      return total;
    },
    selectNum() {
      return this.unPaidBill.table_data.filter((item) => item.checkbox).length;
    }
  },
  watch: {
     show: {
      handler(newValue, oldValue) {

      },
      immediate: false
    }
  },
  mounted() {
    this.billApi = new billApi();
  },
  methods: {
    convertRocDate,
    // 新增標籤
    async addTag(inputAttrs) {
      const value = inputAttrs.value;
      const is_redundant_number = this.unPaidBill.billId.some(item => item === value);

      if (!value || is_redundant_number) return;

      const res = await this.getBill(value);

      if (res.length > 0) {
        this.addBillDataHandler(res);

        this.state = null;
        inputAttrs.value = "";
      } else {
        this.state = false;
      }
    },
    // 移除標籤
    removeTags(...tag) {
      tag.forEach(tag_item => {
        this.unPaidBill.billId = this.unPaidBill.billId.filter(item => item !== tag_item);
        this.unPaidBill.table_data = this.unPaidBill.table_data.filter(item => item.id !== tag_item);
      })
      this.state = null;
    },
    tagName(tag) {
      return this.unPaidBill.table_data.find(item => item.id === tag).number;
    },
    // 核取方塊 全選 || 取消全選 開關
    toggleCheckboxAll() {
      this.unPaidBill.table_data.map(item => {
        if (!item.order_create) this.$set(item, 'checkbox', this.status.isCheckboxAll)
      });
    },
    // 查詢帳單
    getBill(value) {
      return new Promise((resolve) => {
        this.status.isLoading = true;

        const params = {
          'blur': value,
          'class': 1,
        };

        this.billApi.getBill((response) => {
          const res = response.data;

          resolve(res.data);

          this.status.isLoading = false;
        }, params)
      });
    },
    // 新增帳單資料處理
    addBillDataHandler(data = []) {
      data.forEach(bill_item => {
        const is_redundant_number = this.unPaidBill.billId.some(item => item === bill_item.id);

        if (!is_redundant_number) {
          this.unPaidBill.billId.push(bill_item.id);
          this.unPaidBill.table_data = [...this.unPaidBill.table_data, bill_item];
        }
      });
    },
    // 重置搜尋條件
    resetSearchCondition() {
      this.unPaidBill.billId = [];
      this.unPaidBill.table_data = [];
      this.status.isCheckboxAll = false;
    },
    sumit() {
      this.$emit('sumit', this.unPaidBill.table_data);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/BatchMergeBillModal.vue